export default {
    ADD_ALERT: 'ADD_ALERT',
    REMOVE_ALERT: 'REMOVE_ALERT',
    UPDATE_CURRENT_DELIVERY_TYPE: 'UPDATE_CURRENT_DELIVERY_TYPE',
    UPDATE_CURRENT_DELIVERY_RULE: 'UPDATE_CURRENT_DELIVERY_RULE',
    UPDATE_CURRENT_DELIVERY_RULE_TYPE: 'UPDATE_CURRENT_DELIVERY_RULE_TYPE',
    UPDATE_WORKING_DAY_SWITCH: 'UPDATE_WORKING_DAY_SWITCH'
};
